// @flow
import React from "react"

type Props = {
  onClose: number => void,
  bannerText: Array<string>,
}

class AlertModal extends React.Component<Props> {
  componentDidMount() {
    // timeout animation, slide from right after mount
    setTimeout(() => {
      const AlertModalEl = document.getElementById("AlertModal")
      if (AlertModalEl) {
        AlertModalEl.classList.add("shown")
      }
    }, 1500)
  }

  render() {
    const { bannerText, onClose } = this.props
    return (
      <div id="AlertModal" className="AlertModal">
        {bannerText.map((banner, i) => (
          <div className="AlertModal-banner" key={banner}>
            <div className="AlertModal-close" onClick={() => onClose(i)}>
              <i className="spIcon ic_close_bold" />
            </div>
            <span dangerouslySetInnerHTML={{ __html: banner }} />
          </div>
        ))}
      </div>
    )
  }
}

export default AlertModal
